import { render, staticRenderFns } from "./InvoiceEditCard.vue?vue&type=template&id=4ed954be&"
import script from "./InvoiceEditCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports